<div
  class="timeline-layer"
>
  <div
    class="timeline-layer__slider"
    appHorizontalDrag
    (onHorizontalDragStart)="onHorizontalDragStart($event)"
    (onHorizontalDrag)="onHorizontalDrag($event)"
    (onHorizontalDragEnd)="onHorizontalDragEnd($event)"
  >
    <app-timeline-slider>
      <app-timeline-canvas *ngFor="let position of canvasPositions" [position]="position"></app-timeline-canvas>
    </app-timeline-slider>
  </div>

  <div class="timeline-layer-buttons">
    <app-timeline-layer-select [layerId]="layerId"></app-timeline-layer-select>
    <app-timeline-layer-volume [layerId]="layerId"></app-timeline-layer-volume>
  </div>

  <app-timeline-layer-remove [layerId]="layerId"></app-timeline-layer-remove>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer.component.html